import React, { useCallback, useState, createContext, useContext } from 'react';
import { MonthlyUpsellModal } from './MonthlyUpsellModal';
type MonthlyUpsellContextType = {
  showUpsell: () => void;
};
const MonthlyUpsellContext = createContext<MonthlyUpsellContextType>({
  showUpsell: () => {}
});
export function useMonthlyUpsell() {
  return useContext(MonthlyUpsellContext);
}
export function MonthlyUpsellProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const showUpsell = useCallback(() => {
    setIsOpen(true);
  }, []);
  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  return <MonthlyUpsellContext.Provider value={{
    showUpsell
  }} data-id="element-1398">
      {children}
      <MonthlyUpsellModal isOpen={isOpen} onClose={handleClose} data-id="element-1399" />
    </MonthlyUpsellContext.Provider>;
}